export default "__VITE_ASSET__DF2iapcW__";